/** @format */
import {
  AccountingIcon,
  ActionsIcon,
  BellIcon,
  CategoryIcon,
  CategoryOrderIcon,
  ClientsIcon,
  CompanyIcon,
  DepartmentsIcon,
  DistrictIcon,
  DocTypeIcon,
  EmployeeIcon,
  ExpenseManageIcon,
  GateAwaitingIcon,
  GateHistoryIcon,
  GateIcon,
  GateInspectingIcon,
  IncomesIcon,
  InventoryIcon,
  Materials2Icon,
  MaterialsIcon,
  MeasureUnitIcon,
  MeasureWidthHeightIcon,
  NotificationIcon,
  OrdersIcon,
  PercentageIcon,
  PermitsIcon,
  PositionIcon,
  PreferenceIcon,
  PricingIcon,
  ReadyProductIcon,
  RegionIcon,
  RequestManageIcon,
  RolesIcon,
  SalesIcon,
  ServicePriceIcon,
  ServicesSegmentedIcon,
  SettingsIcon,
  TransportationInvoiceIcon,
  UserAvatarIcon,
  VehicleIcon,
  Warehouse2Icon,
  WarehouseForMenuIcon,
  WarehouseManagementIcon,
  WindowThicknessIcon,
} from '@/shared/ui/icons'
import { ArrowDownUp, Hourglass, LayoutDashboard, Receipt } from 'lucide-react'
import { useTranslation } from 'react-i18next'
export const useWarehouseManageItems = () => {
  const { t } = useTranslation()
  const warehouseManageItems = [
    {
      title: t('warehouse-manage'),
      subitems: [
        {
          title: t('warehouse-overview'),
          path: '/warehouse/warehouse-overview',
        },
        {
          title: t('warehouse-management'),
          path: '/warehouse/warehouse-management',
        },
      ],
    },
  ]

  return warehouseManageItems
}

export const useIncomeAndExpenseMaterialsItems = () => {
  const { t } = useTranslation()
  const incomeAndExpenseMaterialsItems = [
    {
      title: t('income-and-expense-materials'),
      subitems: [
        {
          title: t('income-request'),
          path: '/warehouse/income-request',
        },
        {
          title: t('income-materials'),
          path: '/warehouse/income-materials',
        },
      ],
    },
  ]
  return incomeAndExpenseMaterialsItems
}

export const useMonitoringItems = () => {
  const { t } = useTranslation()
  const monitoring = [
    {
      title: t('monitoring'),
      subitems: [
        {
          title: t('stock-level'),
          path: '/warehouse/stock-level',
        },
        {
          title: t('real-time-stock'),
          path: '/warehouse/real-time-stock',
        },
      ],
    },
  ]
  return monitoring
}

export const useInventoryItems = () => {
  const { t } = useTranslation()
  const inventory = [
    {
      title: t('inventory'),
      subitems: [
        {
          title: t('inventory-planning'),
          path: '/warehouse/inventory-planning',
        },
        {
          title: t('inventory-comparison'),
          path: '/warehouse/inventory-comparison',
        },
      ],
    },
  ]
  return inventory
}

export const useCustomerServiceItems = () => {
  const { t } = useTranslation()
  const customerService = [
    {
      title: t('customer-service'),
      subitems: [
        {
          title: t('suppliers-base'),
          path: '/warehouse/suppliers-base',
        },
        {
          title: t('contracts'),
          path: '/warehouse/contracts',
        },
      ],
    },
  ]
  return customerService
}

export const useLogisticsItems = () => {
  const { t } = useTranslation()
  const logistics = [
    {
      title: t('logistics'),
      subitems: [
        {
          title: t('routes-and-delivery-status'),
          path: '/warehouse/routes-and-delivery-status',
        },
        {
          title: t('delivery-control'),
          path: '/warehouse/delivery-control',
        },
      ],
    },
  ]
  return logistics
}
export const useGroupedMenuItems = () => {
  const { t } = useTranslation()
  const groupedMenuItems = [
    {
      label: t('stocks-management'),
      key: 'stocks-management',
      type: 'group',
      children: [
        {
          label: t('warehouses'),
          key: '/warehouse/stocks-management',
          icon: <WarehouseForMenuIcon width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuItems
}
export const useProfileMenuItems = () => {
  const { t } = useTranslation()
  const groupedMenuItems = [
    {
      label: t('profile'),
      key: 'profile_group',
      type: 'group' as const,
      children: [
        {
          label: t('profile'),
          key: '/user/user-profile',
          icon: <UserAvatarIcon color='#ffffff' width={18} height={18} />,
        },
        {
          label: t('notifications'),
          key: '/user/notifications',
          icon: <BellIcon color='#ffffff' width={18} height={18} />,
        },
        {
          label: t('profile_settings'),
          key: '/user/profile-settings',
          icon: <SettingsIcon color='#ffffff' width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuItems
}

export const useGroupedMenuItemsDataLibrary = () => {
  const { t } = useTranslation()

  const groupedMenuItemsDataLibrary = [
    {
      label: t('basic_references'),
      key: 'basic_references',
      name: 'CATEGORY',
      type: 'group',
      icon: <Warehouse2Icon />,
      children: [
        {
          label: t('categories'),
          key: '/data-library/categories',
          name: 'CATEGORY',
          icon: <CategoryIcon width={18} height={18} />,
        },
        {
          label: t('category-order'),
          key: '/data-library/category-order',
          name: 'CATEGORY_ORDER',
          icon: <CategoryOrderIcon width={18} height={18} />,
        },
        {
          label: t('measurement'),
          key: '/data-library/measurement',
          name: 'MEASURE',
          icon: <MeasureUnitIcon width={18} height={18} />,
        },
        {
          label: t('height-length'),
          key: '/data-library/height-length',
          name: 'HEIGHT_LENGTH',
          icon: <MeasureWidthHeightIcon width={18} height={18} />,
        },
        {
          label: t('glass-thickness'),
          key: '/data-library/glass-thickness',
          name: 'WIDTH',
          icon: <WindowThicknessIcon width={18} height={18} />,
        },
        {
          label: t('materials'),
          key: '/data-library/materials',
          name: 'MATERIAL',
          icon: <MaterialsIcon width={18} height={18} />,
        },
        {
          label: t('ready-products'),
          key: '/data-library/ready-products',
          name: 'READY_PRODUCT',
          icon: <ReadyProductIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('equipments'),
          key: '/data-library/equipments',
          name: 'INVENTORY',
          icon: <InventoryIcon width={18} height={18} />,
        },
        {
          label: t('/doc-types'),
          key: '/data-library/doc-types',
          name: 'DOC_TYPE',
          icon: <DocTypeIcon width={18} height={18} />,
        },
      ],
    },
    {
      label: t('organizational_structure'),
      key: 'organizational_structure',
      name: 'COMPANY',
      type: 'group',
      icon: <Warehouse2Icon />,
      children: [
        {
          label: t('/company'),
          key: '/data-library/company',
          name: 'COMPANY',
          icon: <CompanyIcon width={18} height={18} />,
        },
        {
          label: t('/customers'),
          key: '/data-library/customers',
          name: 'CUSTOMER',
          icon: <ClientsIcon width={18} height={18} />,
        },
      ],
    },
    {
      label: t('operational_data'),
      key: 'operational_data',
      name: 'ADDRESS',
      type: 'group',
      icon: <Warehouse2Icon />,
      children: [
        {
          label: t('region'),
          key: '/data-library/regions',
          name: 'ADDRESS',
          icon: <RegionIcon width={18} height={18} />,
        },
        {
          label: t('districts'),
          key: '/data-library/districts',
          name: 'ADDRESS',
          icon: <DistrictIcon width={18} height={18} />,
        },

        {
          label: t('warehouse'),
          key: '/data-library/warehouse',
          name: 'WAREHOUSE',
          icon: <WarehouseForMenuIcon width={18} height={18} />,
        },
        {
          label: t('department'),
          key: '/data-library/departments',
          name: 'DEPARTMENT',
          icon: <DepartmentsIcon width={18} height={18} />,
        },
        {
          label: t('percentage'),
          key: '/data-library/min-max-percentage',
          name: 'DEPARTMENT',
          icon: <PercentageIcon width={18} height={18} />,
        },
        {
          label: t('/transport'),
          key: '/data-library/transport',
          name: 'TRANSPORT',
          icon: <VehicleIcon width={18} height={18} />,
        },
        {
          label: t('/notifications_settings'),
          key: '/data-library/notifications-settings',
          name: 'NOTIFICATION_SETTING',
          icon: <NotificationIcon width={18} height={18} color='#ffffff' />,
        },
      ],
    },
  ]
  return groupedMenuItemsDataLibrary
}

export const useGroupedMenuWarehouseId = (id: string | number) => {
  const { t } = useTranslation()
  const groupedMenuWarehouseId = [
    {
      label: t('materials'),
      key: 'materials',
      name: 'MATERIAL',
      type: 'group',
      icon: <MaterialsIcon />,
      children: [
        {
          label: t('materials'),
          key: `/warehouse/stocks-management/${id}/materials`,
          name: 'MATERIAL',
          icon: <MaterialsIcon width={18} height={18} />,
        },

        {
          label: t('ready_products'),
          key: `/warehouse/stocks-management/${id}/ready-products`,
          name: 'READY_PRODUCT',
          icon: <MaterialsIcon width={18} height={18} />,
        },

        {
          label: t('inventory'),
          key: `/warehouse/stocks-management/${id}/inventory`,
          icon: <InventoryIcon width={18} height={18} />,
        },

        {
          label: t('responsible_person'),
          key: `/warehouse/stocks-management/${id}/responsible-person`,
          name: 'INVENTORY',
          icon: <EmployeeIcon width={18} height={18} />,
        },
      ],
    },
    {
      label: t('actions'),
      key: 'actions',
      name: 'REQUEST',
      type: 'group',
      icon: <ActionsIcon />,
      children: [
        {
          label: t('requests'),
          key: `/warehouse/stocks-management/${id}/requests`,
          name: 'REQUEST',
          icon: <RequestManageIcon width={18} height={18} />,
        },
        {
          label: t('incomes'),
          key: `/warehouse/stocks-management/${id}/incomes`,
          name: 'UNIT_INCOME',
          icon: <IncomesIcon width={18} height={18} />,
        },

        {
          label: t('material-outcomes'),
          key: `/warehouse/stocks-management/${id}/material-outcomes`,
          name: 'UNIT_NOTE',
          icon: <Materials2Icon color='#ffffff' width={18} height={18} />,
        },
      ],
    },
    {
      label: t('stocks-management'),
      key: 'stocks-management',
      name: 'INVENTORY_PROCESS',
      type: 'group',
      icon: <WarehouseManagementIcon />,
      children: [
        {
          label: t('inventorization'),
          key: `/warehouse/stocks-management/${id}/inventorization`,
          name: 'INVENTORY_PROCESS',
          icon: <InventoryIcon width={18} height={18} />,
        },

        {
          label: t('report'),
          key: `/warehouse/stocks-management/${id}/report`,
          name: 'REPORT',
          icon: <Materials2Icon color='#ffffff' width={18} height={18} />,
        },
      ],
    },
    {
      label: t('settings'),
      key: 'settings',
      name: 'WAREHOUSE',
      type: 'group',
      icon: <PreferenceIcon />,
      children: [
        {
          label: t('warehouse_settings_title'),
          key: `/warehouse/stocks-management/${id}/settings`,
          name: 'WAREHOUSE_SETTINGS',
          icon: <SettingsIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('placement_of_material'),
          key: `/warehouse/stocks-management/${id}/placement-of-material`,
          name: 'LABEL',
          icon: <Materials2Icon color='#ffffff' width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuWarehouseId
}
export const useGroupedMenuSupply = (id?: string | number) => {
  const { t } = useTranslation()
  const groupedMenuSupply = [
    {
      label: t('supply'),
      key: 'supply',
      name: 'SUPPLY',
      type: 'group',
      icon: <MaterialsIcon />,
      children: [
        {
          label: t('request-order-short'),
          key: `/supply/request-order`,
          name: 'REQUEST_ORDER',
          icon: <RequestManageIcon width={18} height={18} />,
        },
        {
          label: t('all-orders'),
          key: `/supply/all-orders`,
          name: 'REQUEST_ORDER',
          icon: <OrdersIcon width={18} height={18} />,
        },
        {
          label: t('all-request-permit'),
          key: `/supply/all-request-permit`,
          name: 'REQUEST_PERMIT',
          icon: <PermitsIcon />,
        },
        {
          label: t('transport-invoice'),
          key: `/supply/transport-invoice`,
          name: 'TRANSPORT',
          icon: <TransportationInvoiceIcon />,
        },
      ],
    },
  ]
  return groupedMenuSupply
}
export const useGroupedMenuIncomingDocuments = (id?: string | number) => {
  const { t } = useTranslation()
  const groupedMenuIncomingDocuments = [
    {
      label: t('incoming-documents'),
      key: 'incoming-documents',
      name: 'INCOMING_DOCUMENTS',
      type: 'group',
      icon: <MaterialsIcon />,
      children: [
        {
          label: t('orders'),
          key: `/incoming-documents/orders`,
          name: 'REQUEST_ORDER_SIGNATURE',
          icon: <OrdersIcon />,
        },
        {
          label: t('permits'),
          key: `/incoming-documents/permits`,
          name: 'REQUEST_PERMIT_SIGNATURE',
          icon: <PermitsIcon />,
        },
      ],
    },
  ]
  return groupedMenuIncomingDocuments
}
export const useGroupedMenuFinance = (id?: string | number) => {
  const { t } = useTranslation()
  const groupedMenuFinance = [
    {
      label: t('finance'),
      key: 'finance',
      name: 'FINANCE',
      type: 'group',
      icon: <MaterialsIcon />,
      children: [
        {
          label: t('distribution-of-expenses'),
          key: `/finance/distribution-of-expenses`,
          name: 'TRANSPORTATION',
          icon: <ExpenseManageIcon />,
        },
        {
          label: t('pricing'),
          key: `/finance/pricing`,
          name: 'TRANSPORTATION',
          icon: <PricingIcon />,
        },
        {
          label: t('unit-price'),
          key: `/finance/unit-price`,
          name: 'TRANSPORTATION',
          icon: <PricingIcon />,
        },
      ],
    },
  ]
  return groupedMenuFinance
}
export const useGroupedMenuSales = (id?: string | number) => {
  const { t } = useTranslation()

  const groupedMenuSales = [
    {
      label: t('sales'),
      key: 'sales',
      name: 'SALES',
      type: 'group',
      icon: <SalesIcon width={18} height={18} />,
      children: [
        {
          label: t('templates'),
          key: `/sales/templates`,
          name: 'SALES',
          icon: <MaterialsIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('services'),
          key: `/sales/services`,
          name: 'SALES',
          icon: <ServicesSegmentedIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('service-price-list'),
          key: `/sales/service-price-list`,
          name: 'SALES',
          icon: <ServicePriceIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('orders'),
          key: `/sales/orders`,
          name: 'SALES',
          icon: <OrdersIcon width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuSales
}
export const useGroupedMenuHR = (id?: string | number) => {
  const { t } = useTranslation()

  const groupedMenuHR = [
    {
      label: t('hr'),
      key: 'hr',
      name: 'HR',
      type: 'group',
      icon: <RolesIcon width={18} height={18} />,
      children: [
        {
          label: t('roles'),
          key: `/hr/roles`,
          name: 'HR',
          icon: <RolesIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('positions'),
          key: `/hr/positions`,
          name: 'HR',
          icon: <PositionIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('employees'),
          key: `/hr/employees`,
          name: 'HR',
          icon: <EmployeeIcon width={18} height={18} color='#ffffff' />,
        },
        // {
        //   label: t('signatories'),
        //   key: `/hr/signatories`,
        //   name: 'HR',
        //   icon: <PositionIcon width={18} height={18} />,
        // },
        {
          label: t('sign-groups'),
          key: `/hr/sign-groups`,
          name: 'HR',
          icon: <PositionIcon width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuHR
}
export const useGroupedMenuProduction = (id?: string | number) => {
  const { t } = useTranslation()
  const groupedMenuProduction = [
    {
      label: t('production'),
      key: 'production',
      name: 'PRODUCTION',
      type: 'group',
      icon: <MaterialsIcon />,
      children: [
        {
          label: t('planning'),
          key: `/production/planning`,
          name: 'PRODUCTION',
          icon: <MaterialsIcon width={18} height={18} />,
        },
        {
          label: t('work-stations'),
          key: `/production/work-stations`,
          name: 'PRODUCTION',
          icon: <MaterialsIcon width={18} height={18} />,
        },
        {
          label: t('work-flow-control'),
          key: `/production/work-flow-control`,
          name: 'PRODUCTION',
          icon: <MaterialsIcon width={18} height={18} />,
        },
        {
          label: t('orders-flow-control'),
          key: `/production/orders-flow-control`,
          name: 'PRODUCTION',
          icon: <MaterialsIcon width={18} height={18} />,
        },
      ],
    },
  ]
  return groupedMenuProduction
}
export const useGroupedMenuGate = () => {
  const { t } = useTranslation()
  const groupedMenuGate = [
    {
      label: t('gate'),
      key: 'gate',
      name: 'GATE',
      type: 'group',
      icon: <GateIcon width={18} height={18} />,
      children: [
        {
          label: t('gate:view.awaiting'),
          key: `/gate/awaiting`,
          name: 'GATE',
          icon: <GateAwaitingIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('gate:view.inspecting'),
          key: `/gate/inspecting`,
          name: 'GATE',
          icon: <GateInspectingIcon width={18} height={18} color='#ffffff' />,
        },
        {
          label: t('gate:view.history'),
          key: `/gate/history`,
          name: 'GATE',
          icon: <GateHistoryIcon width={18} height={18} color='#ffffff' />,
        },
      ],
    },
  ]
  return groupedMenuGate
}
export const useGroupedMenuAccounting = () => {
  const { t } = useTranslation()
  const groupedMenuAccounting = [
    {
      label: t('accounting:nav.title'),
      key: 'accounting',
      name: 'ACCOUNTING',
      type: 'group',
      icon: <AccountingIcon width={18} height={18} />,
      children: [
        {
          label: t('accounting:nav.dashboard'),
          key: '/accounting/dashboard',
          name: 'ACCOUNTING',
          icon: <LayoutDashboard size={18} aria-hidden='true' />,
        },
        {
          label: t('accounting:nav.transactions'),
          key: '/accounting/transactions',
          name: 'ACCOUNTING',
          icon: <ArrowDownUp size={18} aria-hidden='true' />,
        },
        {
          label: t('accounting:nav.pending_payments'),
          key: '/accounting/pending-payments',
          name: 'ACCOUNTING',
          icon: <Hourglass size={18} aria-hidden='true' />,
        },
        {
          label: t('accounting:nav.invoices'),
          key: '/accounting/invoices',
          name: 'ACCOUNTING',
          icon: <Receipt size={18} aria-hidden='true' />,
        },
      ],
    },
  ]
  return groupedMenuAccounting
}
export const useMenuItems = () => {
  const { t } = useTranslation()
  const menuItems = [
    {
      label: t('warehouse-manage'),
      key: 'warehouse-manage',
      icon: <WarehouseManagementIcon />,
      children: [
        {
          label: t('warehouse-overview'),
          icon: null,
          key: '/warehouse/warehouse-overview',
        },
        {
          label: t('warehouse-management'),
          icon: null,
          key: '/warehouse/warehouse-management',
        },
      ],
    },
    {
      label: t('income-and-expense-materials'),
      key: 'income-and-expense-materials',
      icon: null,
      children: [
        {
          label: t('income-request'),
          icon: null,
          key: '/warehouse/income-request',
        },
        {
          label: t('income-materials'),
          icon: null,
          key: '/warehouse/income-materials',
        },
      ],
    },
    {
      label: t('monitoring-stock'),
      key: 'monitoring',
      icon: null,
      children: [
        {
          label: t('stock-level'),
          icon: null,
          key: '/warehouse/stock-level',
        },
        {
          label: t('real-time-stock'),
          icon: null,
          key: '/warehouse/real-time-stock',
        },
      ],
    },
    {
      label: t('inventory'),
      key: 'inventory',
      icon: null,
      children: [
        {
          label: t('inventory-planning'),
          icon: null,
          key: '/warehouse/inventory-planning',
        },
        {
          label: t('inventory-comparison'),
          icon: null,
          key: '/warehouse/inventory-comparison',
        },
      ],
    },
    {
      label: t('customer-service'),
      key: 'customer-service',
      icon: null,
      children: [
        {
          label: t('suppliers-base'),
          icon: null,
          key: '/warehouse/suppliers-base',
        },
        {
          label: t('contracts'),
          icon: null,
          key: '/warehouse/contracts',
        },
      ],
    },
    {
      label: t('logistics'),
      key: 'logistics',
      icon: null,
      children: [
        {
          label: t('routes-and-delivery-status'),
          icon: null,
          key: '/warehouse/routes-and-delivery-status',
        },
        {
          label: t('delivery-control'),
          icon: null,
          key: '/warehouse/delivery-control',
        },
      ],
    },
  ]
  return menuItems
}
